import React from 'react';

import { Skeleton as ShadSkeleton } from '@/components/ui/skeleton';

const GROUP_COUNT = 3;
const ROW_COUNT = 3;

const GroupHeader = () => <ShadSkeleton className="h-10 rounded-md" />;

const Row = () => <ShadSkeleton className="h-10 rounded-md" />;

const Group = () => (
  <div className="flex flex-col gap-1">
    <GroupHeader />
    {Array.from({ length: ROW_COUNT }, (_, i) => (
      <Row key={i} />
    ))}
  </div>
);

const Skeleton = () => (
  <div className="flex flex-col gap-4">
    {Array.from({ length: GROUP_COUNT }, (_, i) => (
      <Group key={i} />
    ))}
  </div>
);

export default Skeleton;
